// src/api/inventoryApi.js
import apiClient from "./axios";

const inventoryApi = {
  getAll: async (
    page = 1,
    pageSize = 10,
    sub_category = "",
    ordering = "",
    search = ""
  ) => {
    const params = { page, page_size: pageSize };
    if (sub_category) params.sub_category = sub_category;
    if (ordering) params.ordering = ordering;
    if (search.trim()) params.search = search.trim();

    const res = await apiClient.get("/inventories/", { params });
    return res.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/inventories/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post("/inventories/", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.patch(`/inventories/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/inventories/${id}/`);
  },

  exportCsv: async () => {
    const response = await apiClient.get("/inventories/export/", {
      responseType: "blob",
    });
    return response.data;
  },

  importPreview: async (file) => {
    const form = new FormData();
    form.append("file", file);
    const response = await apiClient.post(
      "/inventories/import-preview/",
      form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  importConfirm: async (preview) => {
    const response = await apiClient.post("/inventories/import-confirm/", {
      preview,
    });
    return response.data;
  },
};

export default inventoryApi;
